// extracted by mini-css-extract-plugin
module.exports = {"form":"MainPage_form__pYFAj","searchButton":"MainPage_searchButton__3YQ1W"};